(function(){
  var BP=900;
  function apply(root,wide){
    root.classList.toggle('is-wide',wide);
    root.querySelectorAll('details[data-desk]').forEach(function(d){
      d.open = wide ? true : d.hasAttribute('data-mobile-open');
    });
  }
  function init(root){
    if(root.__ubpd) return; root.__ubpd=true;
    var last=null;
    function check(){
      var wide=root.getBoundingClientRect().width>=BP;
      // Only act when the layout crosses the breakpoint. Opening or closing a
      // section changes the height, which must not reset what the visitor opened.
      if(wide===last) return;
      last=wide; apply(root,wide);
    }
    check();
    if('ResizeObserver' in window){new ResizeObserver(check).observe(root);}
    else{window.addEventListener('resize',check,{passive:true});}
    // On desktop the always-open sections must not collapse on click.
    root.addEventListener('click',function(e){
      var s=e.target.closest('summary');
      if(s && root.classList.contains('is-wide') && s.parentElement.hasAttribute('data-desk')) e.preventDefault();
    });
  }
  function boot(){document.querySelectorAll('.ubpd').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
